export default __webpack_public_path__ + "static/media/materials.98d01507.svg";